// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1thsD","list":"PatternAutocomplete_list__4jFzH"};